// Import the functions you need from the SDKs you need
import firebase from 'firebase/compat/app';
import 'firebase/compat/database';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyBY8qULtZWJbd_zmukANYWRZ6zYGaN6miY',
  authDomain: 'tracking-real-time-be7d6.firebaseapp.com',
  databaseURL:
    'https://tracking-real-time-be7d6-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'tracking-real-time-be7d6',
  storageBucket: 'tracking-real-time-be7d6.appspot.com',
  messagingSenderId: '1019755311017',
  appId: '1:1019755311017:web:feea1191895973e6989eb8',
  measurementId: 'G-BQPHWTZEMZ',
};

// Initialize Firebase and Firestore
firebase.initializeApp(firebaseConfig);
export default firebase.database();
